module.exports = __webpack_public_path__ + "assets/86da59721c1df2b7fc6eb3dcb15e12bc.png";